import styled from "styled-components";

const TroniqWrapper = styled.section`
  width: 100%;
  padding: 50px 15px;
  background: linear-gradient(45deg, #cceeff, #b3e0ff);
  box-sizing: border-box;
`;

const TroniqContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 25px;
`;

const TroniqInfo = styled.div`
  flex: 1;
  min-width: 250px;
  text-align: center;
`;

const TroniqImage = styled.img`
    max-width: 100%;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
`;

const TroniqText = styled.div`
    flex: 1;
    min-width: 250px;
`;

const TroniqHeader = styled.h2`
    font-size: 32px;
    color: #007acc;
    margin-bottom: 15px;
    font-weight: bold;
`;

const TroniqParagraph = styled.p`
    font-size: 16px;
    color: #4a4a4a;
    line-height: 1.6;
    margin-bottom: 15px;
`;

const About = () => {
  return (
    <TroniqWrapper>
      <TroniqContainer>
        <TroniqText>
          <TroniqHeader>Über Troniq.news</TroniqHeader>
          <TroniqParagraph>
            Bei Troniq.news setzen wir auf die Zukunft der KI-gestützten Plattformen. Unsere Mission ist es, kreative digitale Lösungen zu entwickeln, die den Fortschritt vorantreiben. Basierend in Berlin fördern wir digitale Innovation und die Entwicklung intelligenter Systeme zur Optimierung von Abläufen.
          </TroniqParagraph>
          <TroniqParagraph>
            Unser engagiertes Team arbeitet leidenschaftlich an der Vorwegnahme zukünftiger Herausforderungen und bietet Spitzentechnologie, die neue Möglichkeiten für Unternehmen eröffnet. Entdecken Sie eine Welt voller Chancen!
          </TroniqParagraph>
        </TroniqText>
      </TroniqContainer>
    </TroniqWrapper>
  );
};
export default About;